import { CoachTypes, CoachAction, Coach, AvailableTime, AvailableTimeMap } from '../types';

export function requestAddCoachInfo(
    description: Record<string, string>,
    image: string,
    phoneNumber: string,
    uid: string,
): CoachAction<{ description: Record<string, string>; image: string; phoneNumber: string; uid: string }> {
    return {
        type: CoachTypes.ADD_COACH_INFO,
        payload: { description, image, phoneNumber, uid },
    };
}

export function requestUpdateCoachAvailableTime(
    coachId: string,
    availableTimeMap: AvailableTimeMap,
): CoachAction<{ coachId: string; availableTimeMap: AvailableTimeMap }> {
    return {
        type: CoachTypes.REQUEST_UPDATE_COACH_AVAILABLE_TIME,
        payload: { coachId, availableTimeMap },
    };
}

export function updateCoachAvailableTime(
    coachId: string,
    availableTime: AvailableTime[],
): CoachAction<{ coachId: string; availableTime: AvailableTime[] }> {
    return {
        type: CoachTypes.UPDATE_COACH_AVAILABLE_TIME,
        payload: { coachId, availableTime },
    };
}

export function getListCoach(coach: Coach[]): CoachAction<{ coach: Coach[] }> {
    return {
        type: CoachTypes.GET_LIST_COACH,
        payload: { coach },
    };
}

export function requestGetListCoach() {
    return {
        type: CoachTypes.REQUEST_GET_LIST_COACH,
    };
}

export function coachError(error: string) {
    return {
        type: CoachTypes.COACH_ERROR,
        payload: { error },
    };
}

export function clearCoachError() {
    return {
        type: CoachTypes.CLEAR_COACH_ERROR,
    };
}
